import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import styled, { withTheme } from 'styled-components';
import { navy } from '@zocdoc/branding/colors';
import { breakpoint } from '@zocdoc/components/src/grid';
import { Markdown } from '@zocdoc/components/src/Markdown';
import { PaddedContainer } from '@zocdoc/components/src/Layout';
import { sharpSansMedium } from '@zocdoc/components/src/typography';
import { filterToValidAttributes } from '@zocdoc/dom-property';

const NoResultContainer = styled(PaddedContainer)`
    display: flex;
    justify-content: center;
`;

const NoResultsMessage = styled.div`
    ${sharpSansMedium(18, 24)}
    color: ${navy};
    margin-top: 60px;
    text-align: center;

    ${breakpoint.medium} {
        max-width: 75%;
    }
`;

const NoResults = props => {
    const themeCopy = get(props, 'theme.search.results.noResultsCopy');

    return (
        <NoResultContainer
            {...filterToValidAttributes(props)}
            data-test="search-no-results-message"
        >
            <NoResultsMessage>
                <Markdown source={themeCopy} />
            </NoResultsMessage>
        </NoResultContainer>
    );
};

NoResults.propTypes = {
    theme: PropTypes.shape({
        search: PropTypes.shape({
            results: PropTypes.shape({
                noResultsCopy: PropTypes.string.isRequired,
            }),
        }),
    }),
};

export default withTheme(NoResults);
